import { ConfigTypes } from 'src/AppState/ConfigState/types';

export const features: ConfigTypes = {
    /* A */
    anniversaryInfoShow: false,
    accountTradingCountryClub: false,
    accountTradingDragonCircle: false,
    accountTradingRewardZone: false,
    accountTradingTartanClub: false,
    affiliateIdPromoCode: false,
    activityTimeframe: false,

    /* B */
    betBuilderReferralSwitchShow: true,

    /* C */
    casinoProviders: {
        casino: ['evolution', 'leap', 'pragmatic', 'relax', 'blueprint', 'sg-digital'],
        'live-casino': ['evolution', 'ezugi', 'pragmatic'],
        virtuals: ['leap'],
    },
    closureCodes: true,
    cmsHiddenTabs: ['headlineCarousel'],
    complianceRestrictionSummary: true,
    complianceNew: true,
    contactPreferences: {
        preferences: ['email', 'sms', 'phone'],
        options: ['betting', 'casino'],
        newMarketing: true,
    },
    currencies: ['EUR', 'GBP', 'XTS'],
    cpfProperties: false,
    casinoStoreEnabled: false,

    /* D */
    dashboardTab: false,
    decimalLength: 2,
    depositLimitType: 'rollingType',
    depositLimitCalculationTypeConfigurable: false,
    depositRestriction: true,
    deceased: true,

    /* E */
    externalId: false,

    /* F */
    configurationManagerUI: false,
    failedWithdrawalsFundsEnabled: true,
    footerContentDefault: {
        description_text:
            '© AK BETS All rights reserved. Star Racing Ltd (06475105) (licence number {{licenceNumber}}) is licensed and regulated by the Gambling Commission. Star House, 255 Old Shoreham Road. Hove, East Sussex, BN3 7ED.',
        licence_number: '009177',
        licence_url: 'https://www.gamblingcommission.gov.uk/public-register/business/detail/009177',
        cookies_url: 'https://www.akbets.bet/?account=static&static=cookie-policy',
        has_cookies: true,
    },
    footerLegalTextTab: true,
    fullNameProperties: false,

    /* H */
    hasNewMenu: true,
    hideDeleteImageButtonOnHomePageCarousel: false,
    hasXtremepush: false,

    /* G */
    gamprotect: false,
    gamstopNew: true,
    gamstopPpBlockedSuspendedActions: false,
    golfOnVirtuals: false,
    gtm: 'GTM-KS9KM9Q',

    /* I */
    isAffordability: true,
    isPEP: true,
    identity: true,
    idMission: false,
    isBoostedPriceAvailable: true,
    indexNow: null,

    /* L */
    languages: [
        {
            value: 'en',
            label: 'English',
        },
    ],

    /* O */
    operatorFullName: 'AK Bets',

    /* P */
    personalId: false,
    paymentSearchWalletAddress: false,
    pof: true,
    promotionHistoryEnabled: true,

    /* R */
    realityCheckLimitedType: false,
    reportDownloadOptions: ['View', 'Export to CSV'],
    redirectToNewBetTickerPage: false,
    redirectToNewCMSPage: false,
    redirectToNewTradingPage: false,
    reportsV2: false,
    showRingFencedFunds: true,

    /* M */
    markersOfHarm: true,
    mobilePrefixDisabled: false,
    dopplernegroPrefix: false,
    minDepositAmount: '1',
    minWithdrawAmount: '1',
    minManualAdjustmentAmount: '1',

    /* N */
    newPragmatic: true,
    newPofSrg: true,
    notificationSounds: {
        newChat: 'ding',
        newBetReferral: 'kaching',
    },

    /* S */
    sourceOfFunds: true,
    srgEnabled: true,
    starEventsLabel: 'AK BETS Events',
    showBonusEngine: true,
    showNewCustomerSettings: false,
    showRABInputs: true,
    showBonusCreator: false,

    /* T */
    tableauDashboards: true,
    tagManagementTab: true,
    topEvents: false,

    /* U */
    usePaymentFormForUniverse: {
        type: 'multi-deposit',
        apiKey: 'T1QtMzUwNTAyOkItcDEtMC02OGVkMjYwYS0wLTMwMmMwMjE0MDZjNDQ0NGRlMmI2ZjFjY2Y1ZThhMTYwNDE2ZGY3NmY1Mzc5OWJkMjAyMTQ1ZmVlNzlkODQ4MWIyNTQ2NTQyODIwZWE3ZDIxNGM0NzJlYjNmMGJh',
        environment: 'LIVE',
        cardAccounts: {
            GBP: '1003235382',
            EUR: '1003235392',
        },
        openBanking: 'yaspa',
    },
    userTitleOptional: false,

    /* V */

    /* W */
    withdrawalsTabsShow: true,
    withdrawalStandardLimit: '5000',
    workbookView: {
        ProfitAndLossKPIs: 'ProfitandLossKPIs-AKBets/DailyKPI',
        BackofficeReports: 'BackOfficeReports-AKBets/DB-Casino',
        AccountBalances: 'AccountBalances-AKBets/AccountBalances',
        CasinoDashboard: 'CasinoDashboard-AKBets/CasinoMainDashboard',
        ComplianceDashboard: 'ComplianceDashboard-AKBets/ComplianceMainDashboard',
        MarketingDashboard: 'MarketingDashboard-AKBets/MarketingMainDashboard',
        TransactionsDashboard: 'TransactionsDashboard-AKBets/TransactionsMainDashboard',
        RacecourseDashboard: 'Racecourse-AKBets/TheRacingPartnershipDashboard',
        RollingNetDeposits: 'RollingNetDeposits-AKBets/RollingNetDeposits',
        SymplifyDashboard: 'SymplifyDashboard-AKBets/SymplifyDashboard',
        PlatformOverview: 'Overview-AKBets/Overview',
        SRGCompliance: 'SRGComplianceDashboard-AKBets/DBAverageStakes',
        Accounts: 'Accounts-AKBets/Overview',
        BonusEngine: 'BonusEngine-AKBets/CampaignLevel',
        LiveChat: 'Chats-AKBets/TradersChatsDashboard',
        AuditsCustomerLists: 'AuditCustomerLists-AKBets/Deposits',
        CasinoAudit: 'CasinoAudit-AKBets/CasinoAudit',
    },
};
